module.exports = __webpack_public_path__ + "media/application/images/ui/icon-masthead-mask-d68df584a76c8b565aa3de4415e48e4e.png";